import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontBarlow, fontBarlowSemiCondensed, theme } from "shared/lib/styles";

import { AuthorName } from "scmp-app/components/author/author-name";

export const Container = styled.div``;

export const AuthorNameContainerLabel = styled.span`
  font-weight: 700;
`;

type AuthorNameContainerProps = {
  $isMultipleAuthor: boolean;
};
export const AuthorNameContainer = styled.div<AuthorNameContainerProps>`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 6px;
  justify-content: center;
  align-items: center;

  color: #222222;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: 16.8px;
  letter-spacing: 0.05em;
  white-space: nowrap;
  text-transform: uppercase;

  ${theme.breakpoints.up("desktop")} {
    font-size: 16px;
    line-height: 19.2px;
  }

  ${props =>
    props.$isMultipleAuthor &&
    css`
      gap: 4px 0;
      ${AuthorNameContainerLabel} {
        inline-size: 100%;
      }
    `}
`;

export const AuthorNameWrapper = styled.span`
  & + & {
    &::before {
      content: "/";

      margin-inline: 4px;
    }
  }
`;

export const StyledAuthorName = styled(AuthorName)`
  color: #222222;
`;

type ArticleDateContainerProps = {
  $showSponsorInfo: boolean;
};
export const ArticleDateContainer = styled.div<ArticleDateContainerProps>`
  margin-block-start: 4px;

  color: #a1a1a1;
  font-weight: 600;
  font-size: 14px;
  font-family: ${fontBarlow};
  font-style: normal;
  line-height: normal;
  text-transform: capitalize;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 24px;

    ${props =>
      props.$showSponsorInfo &&
      css`
        margin-block-start: 4px;
      `}
  }
`;

export const SCMPLabLogoContainer = styled.div`
  margin-block-start: 24px;
  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 21px;
  }
`;

export const SponsorInfoContainer = styled.div`
  display: flex;
  justify-content: center;

  margin-block-start: 32px;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 20px;
  }
`;

export const SponsorInfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  align-items: center;

  inline-size: 250px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 450px;
  }
`;

export const SponsorType = styled.span`
  color: #555555;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontBarlowSemiCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
  font-variant-numeric: lining-nums proportional-nums;
`;

export const SponsorName = styled.span`
  color: #555555;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontBarlowSemiCondensed};
  font-style: normal;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;
  font-variant-numeric: lining-nums proportional-nums;
`;
